import React, { FunctionComponent, useState } from "react";
import styles from "./Navigation.module.scss";
import NavigationProps from "./NavigationProps.interface";

import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import IconViewer from "components/IconViewer/IconViewer";

const Navigation: FunctionComponent<NavigationProps> = (props) => {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  return (
    <nav className={styles.wrapper}>
      {props.menu?.map((item: any, index: number) => {
        const children = item.content.subMenu;
        const activeMenuClass =
          currentIndex === index && children.length > 0
            ? styles.is_open
            : undefined;

        return (
          <div key={index} className={styles.item}>
            {/* Level 1 */}
            <span
              onMouseEnter={() => setCurrentIndex(index)}
              onMouseLeave={() => setCurrentIndex(null)}
            >
              <Anchor
                className={combineClasses(styles.link, activeMenuClass)}
                to={item.content.link}
                linkType={item.content?._contentType}
              >
                <span className={styles.link_adjustment}>
                  {item.content.label}
                </span>

                {children && children.length > 0 ? (
                  <IconViewer
                    className={styles.link_icon}
                    name="chevron-down"
                  />
                ) : null}
              </Anchor>
            </span>

            {/* Level 2 */}
            {children && children.length > 0 && currentIndex === index ? (
              <div
                className={styles.dropdown}
                onMouseEnter={() => setCurrentIndex(index)}
                onMouseLeave={() => setCurrentIndex(null)}
              >
                {children.map((subItem: any, subIndex: number) => {
                  return (
                    <Anchor
                      key={subIndex}
                      className={styles.dropdown_link}
                      to={subItem.content.link}
                      linkType={item.content?._contentType}
                    >
                      <span className={styles.link_adjustment}>
                        {subItem.content.label}
                      </span>
                    </Anchor>
                  );
                })}
              </div>
            ) : null}
          </div>
        );
      })}
    </nav>
  );
};

export default Navigation;
